const CARD_USER_ID_STORAGE_KEY = "card_user_selected_id";

export {
  CARD_USER_ID_STORAGE_KEY
}
